import { Text, TextProps } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

/**
 * リンクテキストプロパティ
 */
type ClickableTextProps = PropsWithChildren<
  TextProps &
    Required<Pick<TextProps, 'onClick'>> & {
      hasLink?: boolean;
    }
>;

/**
 * リンクテキスト
 * @param props -
 * @returns
 */
const ClickableText: React.FunctionComponent<ClickableTextProps> = ({
  children,
  hasLink = true,
  ...props
}) => (
  <Text
    color={hasLink ? 'blue.300' : undefined}
    fontWeight={hasLink ? 'bold' : undefined}
    cursor="pointer"
    textAlign="left"
    textDecoration={hasLink ? 'underline' : undefined}
    {...props}
  >
    {children}
  </Text>
);

export default ClickableText;
